export default function tKey<T extends string>(key: T): T {
  return key;
}
